module.exports = __webpack_public_path__ + "images/9b4993b0a0142e089d3ca2a4c5f78049.jpg";


//////////////////
// WEBPACK FOOTER
// ./webpack/assets/img/diaryofanant-characters06.jpg
// module id = ./webpack/assets/img/diaryofanant-characters06.jpg
// module chunks = 0